/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createGlobalBridgeAdminMast = `mutation CreateGlobalBridgeAdminMast(
  $input: CreateGlobalBridgeAdminMastInput!
) {
  createGlobalBridgeAdminMast(input: $input) {
    editAdmin
    getAdmin
    getChildminder
    getRecord
    name
    name_kana
    sub
    isDeleted
    editNotification
  }
}
`;
export const createGlobalBridgeContactBookRecord = `mutation CreateGlobalBridgeContactBookRecord(
  $input: CreateGlobalBridgeContactBookRecordInput!
) {
  createGlobalBridgeContactBookRecord(input: $input) {
    hBreakfast
    child
    createdAt
    hDefecation
    hDefecationTime
    sDefecationState
    sDefecationTime
    hDinner
    sMealType
    sMealAmount
    sMealMenu
    sEvent
    hComment
    hMilk
    hMilkTime
    sMilk
    sMilkTime
    sSleepTotal
    sSleepEnd
    sSleepFrom
    nurseId
    nurseName
    sComment
    hSleepEnd
    hSleepFrom
    hSleepTotal
    sTemperature
    sTemperatureTime
    hTemperature
    hTemperatureTime
    sClassComment
  }
}
`;
export const createGlobalBridgeParentChildMast = `mutation CreateGlobalBridgeParentChildMast(
  $input: CreateGlobalBridgeParentChildMastInput!
) {
  createGlobalBridgeParentChildMast(input: $input) {
    childId
    sub
  }
}
`;
export const updateGlobalBridgeAdminMast = `mutation UpdateGlobalBridgeAdminMast(
  $input: UpdateGlobalBridgeAdminMastInput!
) {
  updateGlobalBridgeAdminMast(input: $input) {
    editAdmin
    getAdmin
    getChildminder
    getRecord
    name
    name_kana
    sub
    isDeleted
    editNotification
  }
}
`;
export const updateGlobalBridgeContactBookRecord = `mutation UpdateGlobalBridgeContactBookRecord(
  $input: UpdateGlobalBridgeContactBookRecordInput!
) {
  updateGlobalBridgeContactBookRecord(input: $input) {
    hBreakfast
    child
    createdAt
    hDefecation
    hDefecationTime
    sDefecationState
    sDefecationTime
    hDinner
    sMealType
    sMealAmount
    sMealMenu
    sEvent
    hComment
    hMilk
    hMilkTime
    sMilk
    sMilkTime
    sSleepTotal
    sSleepEnd
    sSleepFrom
    nurseId
    nurseName
    sComment
    hSleepEnd
    hSleepFrom
    hSleepTotal
    sTemperature
    sTemperatureTime
    hTemperature
    hTemperatureTime
    sClassComment
  }
}
`;
export const updateGlobalBridgeParentChildMast = `mutation UpdateGlobalBridgeParentChildMast(
  $input: UpdateGlobalBridgeParentChildMastInput!
) {
  updateGlobalBridgeParentChildMast(input: $input) {
    childId
    sub
  }
}
`;
export const updateGlobalBridgeSchoolMast = `mutation UpdateGlobalBridgeSchoolMast(
  $input: UpdateGlobalBridgeSchoolMastInput!
) {
  updateGlobalBridgeSchoolMast(input: $input) {
    id
    name
    isVevo
    isEnableVevo
    noteTimeLimit
    isMemoruEnabled
    isDiaryEnabled
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js